<div [ngClass]="'hidden'">
  <div
  class="headerContainer"
  [ngClass]="fullscreenMode ? 'fullscreenMode' : ''">
  </div>
</div>
<div
  class="TopBarHeader"
  [ngClass]="fullscreenMode ? 'fullscreenMode' : ''"
  [ngClass]="''"
>
  <div
    class="headerContainer"
    [ngClass]="fullscreenMode ? 'fullscreenMode' : ''"
  >
    <div class="SPRobotLogo">
      <a (click)="RedirectHome()">
        <img class="logo" src="../../../assets/img/logo/logo-SProbot-v2.svg" alt="" />
      </a>
    </div>
    <div class="login" style="float: right; margin-right: 20px">
      <app-profile></app-profile>
    </div>
  </div>
</div>
